export const GET_SOCKET_REQUEST = "GET_SOCKET_REQUEST";
export const GET_SOCKET_SUCCESS = "GET_SOCKET_SUCCESS";
export const GET_SOCKET_FAILURE = "GET_SOCKET_FAILURE";

export const SET_CUSTOMER_SOCKET_ID = "SET_CUSTOMER_SOCKET_ID";
export const SET_ADMIN_SOCKET_ID = "SET_CUSTOMER_SOCKET_ID";